/**
 * Generic ID generation
 */
const EPOCH = new Date('2016-05-01').getTime()

const Len = {
  ALL: 16,
  TYPE: 2,
  TIME: 10,
  RAND: 4,
}

function padLeft(str: string, padding: string, size: number): string {
  if (str.length >= size) return str

  const diff = size - str.length
  const count = Math.ceil(diff / padding.size)
  const pad = padding.repeat(count).substr(0, diff)
  return pad + str
}

const padZero = (str: string, size: number): string => padLeft(str, '0', size)

/**
 * Create a reusable ID-generation function.
 */
function generateId(objType: number): string {
  assert(objType === (objType|0) && 0 <= objType && objType < 255,
      `ID object type must be an integer in the range [0, 255]: ${objType}`)

  const objPart = padZero(objType.toString(16), Len.TYPE)
  return objPart + createTimestampWithRandId()
}

/**
 * Get the object type from an object ID.
 *
 * @param {string} id
 * @return {number}
 */
function getObjectTypeFromId(id) {
  return parseInt(id.substr(0, Len.TYPE), 16)
}

/**
 * Get the Unix timestamp from an object ID.
 *
 * @param {string} id
 * @return {number}
 */
function getTimestampFromId(id) {
  return EPOCH + parseInt(id.substr(Len.TYPE, Len.TIME), 16)
}

/**
 * Generate a hex-encoded 56-bit timestamp-based sequence with a random part.
 *
 * The first 10 bytes represent the time in milliseconds since the EPOCH,
 * the last 4 bytes are randomly generated to reduce collisions.
 *
 * @return {string}
 */
function createTimestampWithRandId() {
  let time = Date.now() - EPOCH
  const timestampPart = padZero(time.toString(16), Len.TIME)

  const randChars = new Array(Len.RAND)
  for (let i = 0; i < Len.RAND; i++) {
    randChars[i] = Math.floor(Math.random() * 16).toString(16)
  }
  const randPart = randChars.join('')

  return timestampPart + randPart
}

function assert<T>(test: T, msg: string = 'Assertion failed'): T {
  if (!test) {
    throw new Error(msg)
  }

  return test
}

export default {
  generateId,
  getObjectTypeFromId,
  getTimestampFromId,
}



/** WEBPACK FOOTER **
 ** ./src/idgen.js
 **/